import type { RouteRecordRaw } from 'vue-router'

function Layout() {
  return import('@/layouts/index.vue')
}

const routes: RouteRecordRaw = {
  path: '/move_position',
  component: Layout,
  redirect: '/move_position/index',
  name: 'movePosition',
  meta: {
    title: '期货移仓',
    i18n: 'route.tabbar',
    icon: 'game-icons:3d-glasses',
  },
  children: [
    {
      path: 'index',
      name: 'movePositionIndex',
      component: () => import('@/views/move_position/index.vue'),
      meta: {
        title: '期货移仓',
        i18n: 'route.tabbar',
        menu: false,
        breadcrumb: false,
        activeMenu: '/move_position',
      },
    },
  ],
}

export default routes
